import { useRefinedConsoleMenuState } from '../../../../hooks';
import { ALL_CATEGORY } from '../../../../stores';
import { MegaMenuSidebarMenuList, MegaMenuSidebarWrapper } from './MegaMenuSidebarLayout';
import MegaMenuSidebarMenuItem from './MegaMenuSidebarMenuItem';

import type { MegaMenuCategory } from '@kc-console/context';

const Sidebar = () => {
  const { allServices } = useRefinedConsoleMenuState();
  const categoriesWithAll = [{ name: ALL_CATEGORY } as MegaMenuCategory, ...allServices];

  return (
    <MegaMenuSidebarWrapper>
      <MegaMenuSidebarMenuList>
        {categoriesWithAll.map(category => (
          <MegaMenuSidebarMenuItem key={category.name} category={category} />
        ))}
      </MegaMenuSidebarMenuList>
    </MegaMenuSidebarWrapper>
  );
};

export default Sidebar;
